export default __webpack_public_path__ + "static/headerLogo-e520282d3c5e62f2922ff2f6fb160a7f.png";